import * as React from 'react'
import * as PropTypes from 'prop-types'
import moment from 'moment'

import { InlineDatePicker } from 'material-ui-pickers'
import { withStyles } from '@material-ui/core/styles'
import { DataTypeProvider } from '@devexpress/dx-react-grid'

const styles = {
  numericInput: {
    textAlign: 'right',
    width: '100%'
  }
}

const getInputValue = value => (value === undefined ? '' : value)

const Formatter = ({ value }) =>
  value && moment(value).isValid()
    ? moment(value).format('L')
    : `${getInputValue(value)}`

const EditorBase = ({ value, onValueChange, classes }) => {
  const handleChange = targetValue => {
    if (targetValue === '') {
      onValueChange()
      return
    }
    onValueChange(targetValue.format('YYYY-MM-DD'))
  }
  return (
    <InlineDatePicker
      keyboard
      onlyCalendar
      fullWidth
      value={value || ''}
      onChange={handleChange}
      format="DD/MM/YYYY"
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
    />
  )
}

EditorBase.propTypes = {
  value: PropTypes.any,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

EditorBase.defaultProps = {
  value: undefined
}

const Editor = withStyles(styles)(EditorBase)

const availableFilterOperations = [
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
]

const DateTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={Formatter}
    editorComponent={Editor}
    availableFilterOperations={availableFilterOperations}
    {...props}
  />
)

export default DateTypeProvider
